module.exports = __webpack_public_path__ + "static/media/circle_outline_with_exclamation.2e3f04d1.svg";